<template>
    <!-- <div ref="lineChart" id="lineDiv"></div> -->
    <div ref="lineChart"></div>
</template>

<script>
import { lineOption1 as lineOption } from "@/views/report/indicators/option/lineOption";
import * as echarts from "echarts";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      chartRef: {},
    };
  },
  props: {
    ls: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters(["lineData"]),
  },
  watch: {
    lineData: {
      deep: true,
      handler(newVal, oldVal) {
        this.initCharts();
      },
    },
  },
  methods: {
    getIndexMsg() {
      this.initCharts();
    },
    initCharts() {
      if (this.chartRef && this.chartRef._resizeHandler) {
        window.removeEventListener("resize", this.chartRef._resizeHandler);
        this.chartRef.dispose();
      }

      this.chartRef = {};

      const chartDom = this.$refs["lineChart"];

      if (!chartDom) return;

      // chartDom.style.height =
      //   (document.documentElement.clientHeight - 77) / 2 + "px";
      // chartDom.style.border = "1px solid #E9E9E9";

      const myChart = echarts.init(chartDom);

      const option = Object.assign({},lineOption);

      var xAxisData = [];

      var series = [];

      var legendData = [];

      this.ls.forEach((seriesItem, index) => {
        const data = this.lineData[seriesItem.code];
        // x轴数据
        xAxisData = Object.keys(data).map((key) => key);
        // 数据
        var _series = {}
        Object.assign(_series,option.series[0]);
        _series.name = seriesItem.name;
        _series.data = Object.values(data).map((value) =>
          (parseFloat(value) * 100).toFixed(2)
        );
        series.push(_series);

        legendData.push(seriesItem.name);
      });

      option.xAxis[0].data = xAxisData;
      option.series = series;
      option.legend.data = legendData;
      myChart.setOption(option);
      this.chartRef = myChart;

      const resizeHandler = () => {
        myChart.resize();
      };

      window.addEventListener("resize", resizeHandler);
      myChart._resizeHandler = resizeHandler;
    },
  },
  created() {},
  mounted() {
    // this.getIndexMsg();
  },
};
</script>

<style lang="scss">
// #lineDiv {
//   width: 500px;
//   height: 300px;
//   border: 1px solid red;
// }
</style>
